<template>
  <b-navbar toggleable="md" class="navbar navbar-light bg-light">
    <b-navbar-brand href="#" :to="{ name: 'Home' }">
      <img src="@/assets/HRS_Virtual_Training_Logo.png" width="275px;"/>
    </b-navbar-brand>

    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="ml-auto" v-if="currentUser">
        <b-nav-item :to="{ name: 'Home' }" exact-active-class="active">
          Home
        </b-nav-item>
        <b-nav-item-dropdown v-if="currentUser.roles.includes('Administrator') && false">
          <template v-slot:button-content>
            Administration
          </template>
          <b-dropdown-item :to="{ name: 'Students' }" exact-active-class="active">Students</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'Dashboard' }" exact-active-class="active">Calendar</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'Users' }" exact-active-class="active">Users</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'Courses' }" exact-active-class="active">Courses</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'Surveys' }" exact-active-class="active">Surveys</b-dropdown-item>
          <!-- <b-dropdown-item :to="{ name: 'Frame' }" exact-active-class="active">Frame</b-dropdown-item> -->
        </b-nav-item-dropdown>
        <b-nav-item :to="{ name: 'Students' }" exact-active-class="active" v-if="currentUser.roles.includes('Administrator')">Students</b-nav-item>
        <b-nav-item :to="{ name: 'Dashboard' }" exact-active-class="active" v-if="currentUser.roles.includes('Administrator')">Calendar</b-nav-item>
        <b-nav-item :to="{ name: 'Users' }" exact-active-class="active" v-if="currentUser.roles.includes('Administrator')">Users</b-nav-item>
        <b-nav-item :to="{ name: 'Courses' }" exact-active-class="active" v-if="currentUser.roles.includes('Administrator')">Courses</b-nav-item>
        <b-nav-item :to="{ name: 'Surveys' }" exact-active-class="active" v-if="currentUser.roles.includes('Administrator')">Surveys</b-nav-item>
        <b-nav-item :to="{ name: 'Settings' }" exact-active-class="active" v-if="currentUser.roles.includes('Administrator')"><b-icon-gear></b-icon-gear></b-nav-item>
        <b-nav-item-dropdown right>
          <template v-slot:button-content>
            {{currentUser.name}}
          </template>
          <b-dropdown-form><b-form-checkbox v-model="darkMode" switch>Dark Mode</b-form-checkbox></b-dropdown-form>
          <b-dropdown-item :to="{ name: 'EditProfile' }" exact-active-class="active">Profile</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'InstructorSurveys' }" exact-active-class="active" v-if="currentUser.roles.includes('Instructor')">
            Survey Results
          </b-dropdown-item>
          <b-dropdown-item @click="logout">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto" v-if="!currentUser">
        <b-nav-item :to="{ name: 'Login' }" exact-active-class="active">Login</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  data () {
    return {
      darkMode: false
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.auth.currentUser
    }
  },
  mounted () {
    // check for active theme
    const htmlElement = document.documentElement
    const theme = localStorage.getItem('theme')

    if (theme === 'dark') {
      htmlElement.setAttribute('theme', 'dark')
      this.darkMode = true
      this.mode = 'Light Mode'
    } else {
      htmlElement.setAttribute('theme', 'light')
      this.darkMode = false
      this.mode = 'Dark Mode'
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'Login' })
      })
    }
  },
  watch: {
    darkMode (value) {
      const htmlElement = document.documentElement

      if (value) {
        localStorage.setItem('theme', 'dark')
        htmlElement.setAttribute('theme', 'dark')
      } else {
        localStorage.setItem('theme', 'light')
        htmlElement.setAttribute('theme', 'light')
      }
    }
  }
}
</script>

<style scoped>
  .user-dropdown {
    min-width: 0%
  }
  .active {
    font-weight: bold;
  }
</style>
